import { getType } from '@anm/helpers/saga/typesafe-actions';
import { Reducer } from 'redux';

import { pricingActions } from '..';
import { PricingActions, SaleState } from '../types';

const initialSaleState: SaleState = {
  data: null,
  error: null,
  isError: false,
  isPending: false
};

const saleReducer: Reducer<typeof initialSaleState, PricingActions> = (state = initialSaleState, action) => {
  switch (action.type) {
    case getType(pricingActions.setSale): {
      const { payload: sale } = action;

      return {
        ...state,
        data: sale
      };
    }

    default:
      return state;
  }
};

export default saleReducer;
